export const SET_BRAND = 'SET_BRAND';
import axios from 'axios';
export const SET_LOADING_BRAND = 'SET_LOADING_BRAND';
export const SET_BRAND_STORE = 'SET_BRAND_STORE';
export const SET_BRAND_ALERT = 'SET_BRAND_ALERT';
export const UPDATE_BRAND = 'UPDATE_BRAND';

export const setLoadingBrand = (loading) => ({
  type: SET_LOADING_BRAND,
  payload: loading
});

export const setBrand = (brand) => ({
  type: SET_BRAND,
  payload: brand
});

export const setBrandStore = (brand) => ({
  type: SET_BRAND_STORE,
  payload: brand
});

export const setBrandAlert = ({
  content = null,
  variant = 'success',
  shouldUpdateBrand = false,
}) => dispatch => {
  if (shouldUpdateBrand) dispatch(updateBrand());

  dispatch({
    type: SET_BRAND_ALERT,
    payload: content ? {
      content,
      variant
    } : null
  });
};

export const updateBrand = () => ({
  type: UPDATE_BRAND,
  payload: Date.now()
});

export const getBrandInfo = (brandId = null, history) => dispatch => {
  dispatch(setLoadingBrand(true));
  let apiPath = `/api/v1/clients/dashboard?account_id=${brandId || ''}`;
  axios.get(apiPath).then(({ data }) => {
    dispatch(setBrand(data));
    dispatch(setBrandStore({
      path: `/?brand_id=${brandId}`,
      brandId,
    }));
  }).catch((error) => {
    dispatch(setBrand(null));
    dispatch(setBrandStore({ brandId: null }));
  }).finally(() => {
    dispatch(setLoadingBrand(false));
  })
};
